export enum TransformAgent {
  Default = 'default',
  Kinematic = 'kinematic',
  Physics = 'physics',
  Connected = 'connected'
}
